import React from "react";

const IconClose = props => (
  <svg width="33" height="33" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" {...props}>
    <path d="M16.5 0C7.4 0 0 7.4 0 16.5S7.4 33 16.5 33 33 25.6 33 16.5 25.6 0 16.5 0zm6.9 21.3L21.7 23l-5.2-5-5.1 5.1-1.7-1.7 5.1-5.1-5.1-5.1 1.7-1.7 5.1 5.1 5.1-5.1 1.7 1.7-5.1 5.1 5.2 5z" />
  </svg>
);

export default IconClose;
